// extracted by mini-css-extract-plugin
module.exports = {"background":"dd31006766--background--hoSrF","error":"dd31006766--error--1k9Nb"};